import DOMPurify from "dompurify";
import { usePage } from "../../business/Page";

export const GeneratedPage = ({ pageId }: { pageId: string }) => {
  const { page, loading } = usePage(pageId);

  if (loading) {
    return <>Loading...</>;
  }

  if (!page) {
    return <>Page config not found</>;
  }

  const pageConfig = page?.config?.pageConfig as any;
  const sanitizedHtml = DOMPurify.sanitize(pageConfig.html ?? "", {
    ADD_TAGS: ["style"],
  });
  const sanitizedCss = DOMPurify.sanitize(pageConfig.css ?? "", {
    ADD_TAGS: ["style"],
  });

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
      />
      <style>{sanitizedCss}</style>
    </>
  );
};
